import { httpResource } from '@angular/common/http';
import { inject, resource, Service } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { AuthService as Auth0 } from '@auth0/auth0-angular';
import { of } from 'rxjs';
import { environment } from '../../environments/environment';
import { LegacyUser, User } from './user';

@Service()
export class UserDataClient {
  private readonly auth0 = inject(Auth0);

  readonly isAuthenticated = rxResource({
    stream: () => this.auth0.isAuthenticated$,
  }).asReadonly();

  private readonly auth0User = rxResource({
    stream: () => this.auth0.user$,
  }).asReadonly();

  private readonly legacyUser = httpResource<LegacyUser | null>(
    ({ chain }) => {
      const isAuthenticated = chain(this.isAuthenticated);
      return isAuthenticated ? `${environment.apiGatewayUrl}/user` : undefined;
    },
    {
      defaultValue: null,
    },
  ).asReadonly();

  readonly accessToken = rxResource({
    params: ({ chain }) => chain(this.isAuthenticated),
    stream: ({ params: isAuthenticated }) =>
      isAuthenticated ? this.auth0.getAccessTokenSilently() : of(null),
    defaultValue: null,
  }).asReadonly();

  readonly user = resource({
    params: ({ chain }) => ({
      auth0: chain(this.auth0User),
      legacy: chain(this.legacyUser),
    }),
    loader: async ({ params: { auth0, legacy } }) =>
      auth0 && legacy ? ({ ...auth0, legacy } as User) : null,
    defaultValue: null,
  }).asReadonly();
}
